/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// src/components/EditAccountModal.jsx
import React, { useState } from "react";
import RiskSettings from "./RiskSettings";
import AccountForm from "./AccountForm"; 

const EditAccountModal = ({ account, closeModal, refreshAccounts, initialTab = "edit" }) => {
  const [activeTab, setActiveTab] = useState(initialTab); // edit | risk

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div className="bg-backgroundSurface w-full max-w-[95vw] sm:max-w-xl rounded-lg shadow-lg p-4 sm:p-6 max-h-[90vh] overflow-y-auto">
        {/* Header with tabs */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-borderDefault pb-2 gap-2">
          <div className="flex gap-2 sm:gap-4 w-full sm:w-auto">
            <button
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm sm:text-base font-medium ${
                activeTab === "edit" ? "text-primary border-b-2 border-primary" : "text-textSecondary"
              }`}
              onClick={() => setActiveTab("edit")}
            >
              Edit Account
            </button>
            <button
              className={`px-3 sm:px-4 py-1.5 sm:py-2 text-sm sm:text-base font-medium ${
                activeTab === "risk" ? "text-primary border-b-2 border-primary" : "text-textSecondary"
              }`}
              onClick={() => setActiveTab("risk")}
            >
              Risk Settings
            </button>
          </div>
          <button
            onClick={closeModal}
            className="text-textSecondary hover:text-destructive absolute top-4 right-4 sm:relative sm:top-0 sm:right-0"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="mt-4">
          {activeTab === "edit" && (
            <AccountForm
              account={account}
              refreshAccounts={refreshAccounts}
              closeModal={closeModal}
            />
          )}
          {activeTab === "risk" && (
            <RiskSettings
              token={localStorage.getItem("token")}
              accountId={account.id}
              onSaved={() => {
                refreshAccounts();
                closeModal();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAccountModal;
